import { Box } from "@mui/material";

export const TipTapBarDivider = () => (
  <Box
    sx={{
      borderLeft: '1px solid',
      borderColor: 'divider',
      mx: 0.5,
      height: 20,
    }}
  />
);
